// Hace que el elemento .form__width se quede fijo al hacer scroll en la página de producto.
// Se usa porque `position: sticky` a veces no funciona correctamente por overflow o transform en elementos padres.
// Solo se activa en pantallas ≥750px y mantiene el elemento dentro de su contenedor.
// No afecta móviles, garantizando buen rendimiento.

(function stickyFallback() {
  const sticky = document.querySelector('.form__width');
  const container = document.querySelector('.product__content');
  if (!sticky || !container) return;

  const topOffset = parseInt(getComputedStyle(document.querySelector('.form__wrapper')).getPropertyValue('--sticky-top')) || 30;
  let width = sticky.offsetWidth + 'px';

  function updateSticky() {
    // Disable sticky on narrow screens
    if (window.innerWidth < 750) {
      sticky.style.position = '';
      sticky.style.top = '';
      sticky.style.width = '';
      return;
    }
    const triggerBtn = document.getElementById('SI_trigger');
    if (triggerBtn) triggerBtn.style.display = 'none';
    const containerTop = container.getBoundingClientRect().top + window.scrollY;
    const containerBottom = containerTop + container.offsetHeight;
    const stickyHeight = sticky.offsetHeight;
    const scrollY = window.scrollY;

    if (scrollY + topOffset <= containerTop) {
      // Above container
      sticky.style.position = '';
      sticky.style.top = '';
      sticky.style.width = '';
    } else if (scrollY + topOffset + stickyHeight >= containerBottom) {
      // Past container bottom → stick at container bottom
      sticky.style.position = 'absolute';
      sticky.style.top = (container.offsetHeight - stickyHeight) + 'px';
      sticky.style.width = width;
    } else {
      // Inside container → fixed at topOffset
      sticky.style.position = 'fixed';
      sticky.style.top = topOffset + 'px';
      sticky.style.width = width;
    }
  }

  window.addEventListener('scroll', updateSticky);
  window.addEventListener('resize', () => {
    width = sticky.offsetWidth + 'px';
    updateSticky();
  });
  updateSticky();
})();
